import { render } from "./BlacklistMethodAgreementModal.vue?vue&type=template&id=1c48a400&ts=true"
import script from "./BlacklistMethodAgreementModal.vue?vue&type=script&lang=ts"
export * from "./BlacklistMethodAgreementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__